import React from 'react';
import SolidButton, { SolidButtonProps } from '../../../../../Buttons/SolidButton';

interface Props extends Omit<SolidButtonProps, 'size' | 'variant'> {}

const DestructiveConfirmButton: React.FC<Props> = ({ children, ...rest }) => (
  <SolidButton size="large" variant="destructive-red" {...rest}>
    {children}
  </SolidButton>
);
DestructiveConfirmButton.displayName = 'DestructiveConfirmButton';

export default DestructiveConfirmButton;
